export enum MonitorType {
  Dataset = 'Dataset',
  License = 'License'
}
